import { hcpType } from "../util/constants";

export async function getContainerMessage(messageCode, prescriberId, productId, messageTypeId, excludePrintRestrictedPlans = false, prescriberType = 'Prescriber') {
	if (!messageCode || !prescriberId || !productId || (!messageTypeId && messageTypeId !== 0)) {
		throw new Error('Missing required parameters');
	}

    let apiEndPoint;
    if (prescriberType === hcpType.Prescriber) {
        apiEndPoint = 'Prescriber';
    } else if (prescriberType === hcpType.GroupPractice) {
        apiEndPoint = 'GroupPractice';
    } else if (prescriberType === hcpType.GeographyAggregate) {
        apiEndPoint = 'GeographyAggregate';
    } else {
        throw new Error("Invalid argument: prescriberType");
    }
	const url = `${process.env.REACT_APP_API_URL}${apiEndPoint}/ContainerMessage/${encodeURIComponent(messageCode)}/${encodeURIComponent(prescriberId)}/${encodeURIComponent(productId)}/${encodeURIComponent(messageTypeId)}?excludePrintRestrictedPlans=${encodeURIComponent(excludePrintRestrictedPlans)}`;
	const response = await fetch(url, {
		method: 'GET',
		credentials: 'include',
	});

	if (response.status === 200) {
		return await response.json();
	} else {
		throw response.statusText;
	}
}
